export const base64UrlToBase64 = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');

  return base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
};
